export async function* StreamToIterable(
  stream?: ReadableStream
): AsyncGenerator<Uint8Array> {
  if (!stream) return
  const reader = stream.getReader()
  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      yield value
    }
  } finally {
    reader.releaseLock()
  }
}
